import styled from "styled-components";

export const TipsAccordionButton = styled.button`
  color: ${({ theme }) => theme.colors.primary300};
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  border-radius: 8px;
  padding: 12px 24px;
  margin-bottom: 8px;
  cursor: pointer;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    opacity: 0.8;
  }
`;
export const TipsAccordionArrow = styled.span<{ open: boolean }>`
  display: inline-flex;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(${({ open }) => (open ? "0deg" : "180deg")});
`;

export const TipsAccordionContent = styled.div<{ open: boolean }>`
  max-height: ${({ open }) => (open ? "550px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${({ open }) => (open ? 1 : 0)};
  pointer-events: ${({ open }) => (open ? "auto" : "none")};
`;

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.netural100};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 16px;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    margin-top: 24px;
    padding: 0 8px;
  }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 2px 0px rgba(24, 30, 45, 0.05),
    0px 0px 10px 0px rgba(64, 56, 95, 0.05),
    0px 0px 40px 0px rgba(81, 94, 108, 0.05);
  border-radius: 8px;
  padding: 40px;
  max-width: 636px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    padding: 16px;
    max-width: 100%;
  }
`;

export const Title = styled.h2`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 34px;
  color: ${({ theme }) => theme.colors.primary600};
  text-align: center;
  margin-bottom: 40px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 16px;
  }
`;

export const Important = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.primary600};
  margin-bottom: 8px;
  text-align: left;
`;

export const Description = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.netural800};
  margin-bottom: 24px;
  text-align: center;
`;

export const TipsCard = styled.div`
  background-color: ${({ theme }) => theme.colors.netural100};
  border-radius: 8px;
  padding: 24px;
  max-width: 476px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`;

export const TipRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const TipIcon = styled.div`
  background: #23d0c5;
  border-radius: 8px;
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

export const TipText = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.netural800};
  margin: 0;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  width: 360px;
  max-width: 100%;
  margin-bottom: 24px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
    max-width: 360px;
  }
`;

export const Label = styled.label`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.netural800};
  margin-bottom: 4px;
`;

export const Input = styled.input`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 8px;
  height: 56px;
  width: 100%;
  padding: 0 16px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.netural800};
  margin-bottom: 8px;
  ::placeholder {
    color: ${({ theme }) => theme.colors.netural300};
  }
`;

export const SubmitButton = styled.button`
  background: ${({ theme }) => theme.colors.primary300};
  color: #fff;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  padding: 16px 32px;
  box-shadow: 0px 10px 20px -10px rgba(91, 121, 217, 0.3),
    0px 5px 30px -5px rgba(91, 121, 217, 0.2);
  cursor: pointer;
  width: 160px;
  margin: 0 auto;
  display: block;
  opacity: 1;
  transition: background 0.2s, opacity 0.2s;
  &:disabled {
    background: ${({ theme }) => theme.colors.netural300};
    color: ${({ theme }) => theme.colors.netural500};
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
  }
`;
